import { render, staticRenderFns } from "./index.vue?vue&type=template&id=460363e6&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {GeneralBreadcrumbs: require('/home/nvpa/nvpa-corporate/nuxt/components/general/Breadcrumbs.vue').default,NewsItem: require('/home/nvpa/nvpa-corporate/nuxt/components/news/Item.vue').default,GeneralPagination: require('/home/nvpa/nvpa-corporate/nuxt/components/general/pagination.vue').default})
